module.exports = __webpack_public_path__ + "images/fa-cfa-review-10.webp";